import type { CallRecordListItem } from '@yeshuman/sdk'

export type TriagePet = { name: string; species?: string | null }

/** Pets named on the call (vet urgency classifier, via the board row extension). */
export function petsSubtitle(row: CallRecordListItem): string | null {
  const pets = row.triage_pets as TriagePet[] | undefined
  if (!pets?.length) return null
  return pets
    .map((p) => {
      const sp = p.species?.trim()
      return sp ? `${p.name} (${sp})` : p.name
    })
    .join(' · ')
}
